import { SpinnerWrapper } from "./Spinner.styled";

const Spinner = ({ text }) => (
  <SpinnerWrapper>
    <p>{text}</p>
    <img src="/assets/svg/status.svg" alt="spinner" loading="lazy" />
  </SpinnerWrapper>
);

export default Spinner;
